"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("./styles");

var _styles2 = require("@material-ui/core/styles");

var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));

var _Typography = _interopRequireDefault(require("../Typography/Typography"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _clsx = _interopRequireDefault(require("clsx"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Checkbox = function Checkbox(_ref) {
  var classes = _ref.classes,
      label = _ref.label,
      value = _ref.value,
      _onChange = _ref.onChange,
      disabled = _ref.disabled;
  return _react["default"].createElement(_Grid["default"], {
    container: true,
    spacing: 1
  }, _react["default"].createElement(_Grid["default"], {
    item: true
  }, _react["default"].createElement(_Checkbox["default"], {
    disableRipple: true,
    className: classes.root,
    checkedIcon: _react["default"].createElement("span", {
      className: (0, _clsx["default"])(classes.icon, classes.checkedIcon)
    }),
    icon: _react["default"].createElement("span", {
      className: classes.icon
    }),
    checked: value,
    disabled: disabled,
    onChange: function onChange(e) {
      return _onChange(e.target.checked);
    }
  })), _react["default"].createElement(_Grid["default"], {
    item: true
  }, _react["default"].createElement(_Typography["default"], {
    type: "label"
  }, label)));
};

var _default = (0, _styles2.withStyles)(_styles.styles)(Checkbox);

exports["default"] = _default;